export class Position {
  constructor(public x: number,
              public y: number,
              public z: number) {
  }
}


// WEBPACK FOOTER //
// ./src/app/classes/position.ts